import { LCV_ROUTE_CITIES } from "../../lcv-route-landing/data/lcvRouteCities";
import cityPagesManifest from "./cityPages.manifest.json";
import { getVerifiedCityHreflangLocales } from "./cityLocaleSlugs";
import { CityPageConfig } from "./types";

type CityKey = keyof typeof LCV_ROUTE_CITIES;

type CityManifestEntry = {
    slug: string;
    hreflangLocales: string[];
};

const defineCity = (slug: CityKey, hreflangLocales: string[]): CityPageConfig => ({
    slug,
    hreflangLocales,
    city: LCV_ROUTE_CITIES[slug]
});

/** City list — edit cityPages.manifest.json only. */
export const CITY_PAGES: CityPageConfig[] = (cityPagesManifest as CityManifestEntry[]).map(
    ({ slug, hreflangLocales }) => defineCity(slug as CityKey, getVerifiedCityHreflangLocales(slug, hreflangLocales))
);

export const cityPagesBySlug = Object.fromEntries(CITY_PAGES.map((city) => [city.slug, city])) as Record<
    string,
    CityPageConfig
>;

export const getCityPageSlugs = () => Object.keys(cityPagesBySlug);

export const getCityPageBySlug = (slug: string) => cityPagesBySlug[slug];

export const getCityPagePath = (slug: string) => `/city/${slug}`;
